import { Component, OnInit, Inject, EventEmitter, Output, Input } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import { CommonService } from 'src/app/core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
	selector: 'app-workshop-reassignment-dialog',
	templateUrl: './workshop-reassignment-dialog.component.html',
	styleUrls: ['./workshop-reassignment-dialog.component.scss']
})
export class WorkshopReassignmentDialogComponent implements OnInit {

	Remarks: string = '';
	customerName: string = '';
	customerTelephone: string = '';
	nearestWorkshop: string = '';
	chassis: string = '';
	customerCode: string = '';
	chassisArray: string[] = [];
	selectedChassis: string[] = [];
	selectedStatus: any;
	assignmentIndicator: any;
	enableSearch: boolean = true;
	workshopSearch = new FormControl();
	filteredOptions: Observable<string[]>;
	workshopSuggestion: string[] = [];
	spinner: boolean;
	userId: any;
	custResData: custData;
	countryCode: any;
	workshopCode: String;

	constructor(
		public dialog: MatDialog,
		private router: Router,
		private commonService: CommonService,
		private toastr: ToastrService,
		private dialogRef: MatDialogRef<WorkshopReassignmentDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.customerName = data.customerName;
		this.customerTelephone = data.customerTelephone;
		this.nearestWorkshop = data.nearestWorkshop;
		this.chassis = data.chassis;
		this.customerCode = data.customerCode;
	}

	ngOnInit() {
		this.userId = localStorage.getItem('userId');
		this.countryCode = localStorage.getItem("countryCode");
		this.getVehicleDetails();
		this.filteredOptions = this.workshopSearch.valueChanges.pipe(
			startWith(''),
			map(value => this._filter(value))
		);
		this.commonService.LostCustWorkshopDetailsFilter().subscribe(res => {
			if (res['responseCode'] == 0 && res['responseData'] != undefined) {
				res['responseData'].forEach(element => {
					this.workshopSuggestion.push(element.customerCity);
				})
			} else {
				this.toastr.error(res['message'], "Error");
			}
		}, err => {
			this.toastr.error("Something went wrong, Please try again.", "Error");
		});
	}

	getVehicleDetails() {
		this.commonService.lcWorkshopReassignmentVehicleDetails(this.customerCode).subscribe(res => {
			if (res['responseCode'] == 0 && res['responseData'] != undefined) {
				if (res['responseData'].length != 0) {
					res['responseData'].forEach(element => {
						if (element.registrationNo != null || element.registrationNo != "") {
							this.chassisArray.push(element.registrationNo);
						}
						else {
							this.chassisArray.push(element.chassisNo);
						}
					});
				}else{
					this.toastr.error("No vehicle Found", "Error");
				}
			} else {
				this.toastr.error(res['message'], "Error");
			}
		}, err => {
			this.toastr.error("Something went wrong, Please try again.", "Error");
		});
	}

	onClose() {
		this.dialogRef.close();
	}

	private _filter(value: string): string[] {
		if (value.length >= 3) {
			let filterValue = value.toLowerCase();
			return this.workshopSuggestion.filter(option =>
				option.toLowerCase().includes(filterValue)
			);
		}
	}

	selectedLeadStatus() {
		if (this.selectedStatus == "Workshop Reassign") {
			this.enableSearch = false;
			this.assignmentIndicator = "reassigned";
		}
		else {
			this.assignmentIndicator = "closed"
			this.enableSearch = true;
			this.workshopSearch.patchValue("");
		}
	}

	onSubmit() {
		if (this.selectedChassis == null || (this.Remarks == null || this.Remarks == "") || this.selectedStatus == null) {
			this.toastr.error("Please fill required fields");
		} else if (this.enableSearch == false && (this.workshopSearch.value == null || this.workshopSearch.value == "")) {
			this.toastr.error("Please fill required fields");
		}
		else {
			this.workshopCode = this.workshopSearch.value.toString()
			this.workshopCode = this.workshopCode.substring(
				this.workshopCode.indexOf("->") + 2,
				this.workshopCode.lastIndexOf("->")
			);
			this.custResData = new custData(
				this.customerCode,
				this.selectedChassis,
				this.workshopCode,
				this.assignmentIndicator,
				this.Remarks,
				this.userId,
				this.countryCode
			)
			this.spinner = true;
			this.commonService.saveWorkshopReassignment(this.custResData).subscribe(res => {
				if (res["responseCode"] == 0 && res["responseData"] != undefined) {
					this.toastr.info(res['message'], "Success");
					this.spinner = false;
					if(res['message'] != null || res['message'] != ""){
						this.dialogRef.close(-1);
					}
				} else {
					this.toastr.error(res['message'], "Error");
					this.spinner = false;
					this.onClose();
				}
			}, error => {
				this.spinner = false;
				this.toastr.error("Something went wrong, Please try again.", "Error");
				this.onClose();
			});
		}
	}
}

export function openWorkshopReassignmentDialog(dialog: MatDialog, customerName: any, customerTelephone: any, nearestWorkshop: any, chassis: any, customerCode: any) {
	const config = new MatDialogConfig();
	config.disableClose = true;
	config.autoFocus = true;
	config.width = '848px';
	config.height = '400px';
	config.data = {
		customerTelephone: customerTelephone,
		nearestWorkshop: nearestWorkshop,
		customerName: customerName,
		chassis: chassis,
		customerCode: customerCode
	};
	const dialogRef = dialog.open(WorkshopReassignmentDialogComponent, config);
	return dialogRef.afterClosed();
}

class custData {
	customerCode: string;
	vin: string[];
	newWorkshopCode: string;
	assignmentIndicator: string;
	remark: string;
	userId: string;
	countryCode: string;


	constructor(
	  customerCode,
	  vin,
	  newWorkshopCode,
	  assignmentIndicator,
	  remark,
	  userId,
	  countryCode,

	) {
	  this.customerCode = customerCode;
	  this.vin = vin;
	  this.newWorkshopCode = newWorkshopCode;
	  this.assignmentIndicator = assignmentIndicator;
	  this.remark = remark;
	  this.userId = userId;
	  this.countryCode = countryCode;

	}
}
